import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

	constructor(private authService: AuthService, private router: Router) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (this.authService.isLoggedIn()) {
			console.log('Logged in');
			return true;
		}

		this.router.navigate(['/login']);

		console.log('Logged out');
		return false;
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/guards/auth.guard.ts